var map = {
	"./about-us-banner-cn.webp": 1885,
	"./about-us-banner.webp": 371,
	"./banner-01.jpg": 1886,
	"./banner-slot.jpg": 1887,
	"./bet-and-earn-banner-cn.webp": 1888,
	"./bet-and-earn-banner-indon.webp": 1889,
	"./bet-and-earn-banner-ms.webp": 1890,
	"./bet-and-earn-banner.webp": 1891,
	"./check-in-banner-cn.webp": 1892,
	"./check-in-banner-id.webp": 1893,
	"./check-in-banner-ms.webp": 1894,
	"./check-in-banner.webp": 1895,
	"./cny_2024-bm.webp": 1896,
	"./cny_2024-cn.webp": 1897,
	"./cny_2024.webp": 1898,
	"./epl-banner-cn.webp": 1899,
	"./epl-banner-indo.webp": 1900,
	"./epl-banner-ms.webp": 1901,
	"./epl-banner.webp": 1902,
	"./lb-m-banner-cn.webp": 1903,
	"./lb-m-banner.webp": 1904,
	"./leaderboard-banner-cn.webp": 1905,
	"./leaderboard-banner.webp": 1906,
	"./lottery-banner.webp": 1907,
	"./lucky-spin-banner-cn.webp": 1908,
	"./lucky-spin-banner-ms.webp": 1909,
	"./lucky-spin-banner.webp": 1910,
	"./p2p-banner.webp": 1911,
	"./premier-league-banner-cn.webp": 1912,
	"./premier-league-banner.webp": 1913,
	"./promo-vip-banner-cn.webp": 1914,
	"./promo-vip-banner.webp": 1915,
	"./promos-banner-cn.webp": 1916,
	"./promos-banner-indon.webp": 1917,
	"./promos-banner-ms.webp": 1918,
	"./promos-banner.webp": 1919,
	"./promos-detail-banner.jpg": 1920,
	"./side-bar-banner.jpg": 1921,
	"./vip-banner-cn.webp": 1922,
	"./vip-banner-id.webp": 1923,
	"./vip-banner-mobile.webp": 1924,
	"./vip-banner-ms.webp": 1925,
	"./vip-banner.webp": 1926,
	"./winner-leaderboard-banner-cn.webp": 1927,
	"./winner-leaderboard-banner.webp": 1928,
	"./world-cup-banner-cn.webp": 1929,
	"./world-cup-banner.webp": 1930,
	"./world-cup-two-banner-cn.webp": 1931,
	"./world-cup-two-banner.webp": 1932,
	"./xmas_2023-bm.jpg": 1933,
	"./xmas_2023-cn.jpg": 1934,
	"./xmas_2023-id.jpg": 1935,
	"./xmas_2023.jpg": 1936
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59;